import { NewsResponseItem, NewsItem } from '@/types/News'
import { formatNewsDate } from '@/utils/newsUtils'
import { getWpThumbnailUrl } from '@/utils/wpRestApiUtils'

// NOTE: レスポンスをリポジトリ層に閉じ込めるための変換
// - ネストしたプロパティの存在確認をViewで行うと煩雑になるので、フラットなメンバーで返却する
export function convertNewsItem(
  newsReponseItem: Pick<NewsResponseItem, 'id' | 'date' | 'title' | 'thumbnail'>
): NewsItem {
  return {
    id: newsReponseItem.id,
    date: newsReponseItem.date,
    displayDate: formatNewsDate(newsReponseItem.date),
    title: newsReponseItem.title.rendered,
    thumbnailUrl: getWpThumbnailUrl(newsReponseItem.thumbnail)
  }
}
